import { IDevice } from 'app/shared/model/device.model';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';

export interface IDeviceTruckImplement {
  id?: number;
  serial?: string | null;
  firmware?: string | null;
  device?: IDevice | null;
  truckImplement?: ITruckImplement | null;
  imei?: string | null;
  iccid?: string | null;
  reverseTireOrder?: boolean | null;
}

export const defaultValue: Readonly<IDeviceTruckImplement> = {};
